import React, {useState} from 'react';
import {SummaryComponent} from './components/Common/SummaryComponent';
import {VexWorkbenchList} from './components/VexWorkbench/VexWorkbenchList';
import {KeywordStatus} from 'types';
import {useUserContext} from 'authentication/UserContext';
import {
	useTheme,
	TextCompat as Text,
	StackCompat as Stack,
} from 'components/FluentUICompat';
import {getDashboardClassNames} from './components/Common/BaseWorkBenchComponent';
import {useTranslation} from 'react-i18next';
import {MyRequirementsItems} from './components/VexWorkbench/MyRequirementsItems';

export const DashboardPageVexPart = () => {
	const theme = useTheme();
	const classNames = getDashboardClassNames(theme);
	const {isVex, isVexSupport} = useUserContext();

	const {t} = useTranslation('features/dashboard', {
		keyPrefix: 'DashboardPage',
	});

	const [vexRequirementCount, setVexRequirementCount] = useState<
		number | undefined
	>(undefined);

	// Don't show "In Assessment" list for VEX Support users
	const renderVexWorkbenchLists = () => (
		<>
			{!isVexSupport && (
				<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.New} />
			)}
			<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.Accepted} />
			<VexWorkbenchList halfHeight keywordStatus={KeywordStatus.Finalized} />
		</>
	);
	return (
		<>
			{isVex && <SummaryComponent requirementCount={vexRequirementCount} />}
			{isVex && (
				<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
					<Text className={classNames.WorkbenchHeaderText}>
						{t('RegulationsOverviewHeader')}
					</Text>
				</Stack>
			)}
			<Stack horizontal horizontalAlign='start'>
				{isVex && (
					<Stack horizontal styles={{root: {width: '100%'}}} grow={1}>
						{isVex && renderVexWorkbenchLists()}
					</Stack>
				)}
			</Stack>

			{isVex && (
				<>
					<Stack horizontalAlign='start' className={classNames.WorkbenchHeader}>
						<Text className={classNames.WorkbenchHeaderText}>
							{t('ReqsOverviewHeader')}
						</Text>
					</Stack>
					<Stack
						horizontal
						horizontalAlign='start'
						styles={{root: {width: '100%', overflowX: 'hidden'}}}
						grow={1}
					>
						<MyRequirementsItems
							halfHeight
							itemCountLoaded={(count: number) => setVexRequirementCount(count)}
						/>
					</Stack>
				</>
			)}
		</>
	);
};
